import Navbar from "react-bootstrap/Navbar";
import { Image } from "react-bootstrap";
function Footer() {
  return (
    <Navbar as="div" data-bs-theme="dark"
      className="bg-body-tertiary justify-content-evenly border-top mt-5 p-1 transicao"
      fixed="bottom"
    >
      <Navbar.Brand className="mb-0 p-0 fs-6">
        <Image src="../favicon.ico" title="Logo de RMV" width="35"
      height="35"/> Developed by RMV 2024-2026
      </Navbar.Brand>
    </Navbar>
  );
}
export default Footer;
